import axios from "axios";
import store from "@/store";

export function apiGet(token, request, page, params, per_page = 1000, debug) {
  axios.interceptors.request.use(
    function (config) {
      config.metadata = { startTime: new Date() };
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );
  return axios
    .get(
      `${
        process.env.VUE_APP_API_URL + request
      }page=${page}&per_page=${per_page}`,
      {
        params: params,
        headers: {
          Authorization: "Bearer " + token
        }
      }
    )
    .then(response => {
      if (debug) {
        response.config.metadata.endTime = new Date();
        response.duration =
          response.config.metadata.endTime - response.config.metadata.startTime;
        return response;
      }
      return response.data;
    })
    .catch(() => {
      return "You are unauthorized.";
    });
}
export function apiPatch(token, request, data) {
  return axios
    .patch(`${process.env.VUE_APP_API_URL + request}`, data, {
      headers: {
        Authorization: "Bearer " + token
      }
    })
    .then(response => {
      return response.data;
    });
}
